import {ActionContext} from "vuex";
import {IAppState} from "@/interfaces/app-state.interface";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {ICorp} from "@/modules/Corps/interfaces/corp.interface";

export namespace ICorpsStore {
  type CorpsStoreType = ActionContext<ICorpsStore.IState, IAppState>;

  export interface ICorpStoreModule {
    namespaced: boolean;
    state: ICorpsStore.IState;
    mutations: {
      setProperty(state: ICorpsStore.IState, payload: { name: string, value: any }): void;
      setSubProperty(state: ICorpsStore.IState, payload: { block: string, name: string, value: any }): void;
      startLoading(state: ICorpsStore.IState): void;
      stopLoading(state: ICorpsStore.IState): void;
      setSorting(state: ICorpsStore.IState, cell: IAppTable.ITableProp): void;
      addNewTableItem(state: ICorpsStore.IState, payload: { corp: ICorp.IEntity }): void;
      updateTableItem(state: ICorpsStore.IState, payload: { corp: ICorp.IEntity }): void;
    };
    getters: {
      sortedList: Function;
    };
    actions: {
      init(context: CorpsStoreType): Promise<void>;
      getTable(context: CorpsStoreType): Promise<void>;
      clearFilters(context: CorpsStoreType): Promise<void>;
    };
  }

  export interface IState {
    table: ICorp.IEntity[];
    filters: IFilters;
    sortingTable: IAppTable.ISortingData;
    tableName: string;

    loading: boolean;
  }

  export interface IFilters {
    fltOwnerCorpId: number;
    fltStr: string;
    fltEnabled: boolean;
  }

  export const DefaultFilters: IFilters = {
    fltOwnerCorpId: null,
    fltStr: '',
    fltEnabled: true,
  };
}